<template>
  <div class="video_detail_container">
    <div class="video_box">
      <div class="player_box" v-if="!!videoInfo && videoInfo.videoList">
        <video controls controlslist="nodownload" disablepictureinpicture :src="videoInfo.videoList[0].playUrls[0].playUrl" :poster="videoInfo.videoList[0].playUrls[0].coverUrl" v-if="videoInfo.videoList.length>0"></video>
      </div>
      <div class="detail_box" ref="detailBox">
        <!-- 详情 -->
        <div class="detail_info" v-if="!!videoInfo" ref="videoInfoBox">
          <div class="title" v-text="videoInfo.title"></div>
          <div class="detail_text">
            <span class="source" v-text=" !!videoInfo.source && videoInfo.source != '' ? videoInfo.source : appName"></span>
            <span class="time" v-text="videoInfo.publishTime"></span>
          </div>
          <div class="detail_cont" v-text="videoInfo.summary"></div>
        </div>
        <!-- 相关视频 -->
        <related-video :list="videoInfo.relatedList" v-if="
            !!videoInfo &&
            videoInfo.relatedList &&
            videoInfo.relatedList.length > 0
          "></related-video>
        <!-- 评论 -->
        <div ref="comment">
          <comment :params="commentParams" @replyForm="showCommentReplayForm" v-if="!!videoInfo"></comment>
        </div>
      </div>
    </div>
    <!-- 底部操作 -->
    <operate :params="detailParams" :id="videoInfo.id" :contentId="videoInfo.contentId" :contentTitle="videoInfo.title" :isCollect="videoInfo.isCollect" :likeType="videoInfo.likeType" :allowLikes="videoInfo.likesSupport" :allow="videoInfo.allowComment" v-if="!!videoInfo" @isToComment="isToComment" @showCommentForm="showCommentForm"></operate>
    <!-- 发布评论 -->
    <submit-comment v-if="!!videoInfo" :show="isShowCommentForm" :id="videoInfo.id" :type="videoInfo.contentType" :parentId="commentParentId" :title="videoInfo.title" @showCommentForm="showCommentForm"></submit-comment>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat, clickPlayCount, addScore } from "@/utils";
import { trackArticleDetailPg } from "@/utils/qt.js";
import videoApi from "@/api/apis/video.js";
import commApi from "@/api/apis/common.js";
import RelatedVideo from "./components/RelatedVideo"; // 相关视频
import comment from "./components/Comment"; // 评论
import operate from "./components/Operate"; //底部
import submitComment from "./components/SubmitComment"; //发表评论
export default {
  name: "VideoDetail",
  data() {
    return {
      /* 是否显示评论表单 */
      isShowCommentForm: false,
      commentParentId: "0",
      /* 获取详情所需的参数 */
      detailParams: {
        contentType: null,
        contentId: null,
        fromFlag: null,
        cId: null,
      },
      /* 获取评论列表的参数 */
      commentParams: {
        contentId: null,
        type: null,
      },
      videoInfo: null, //视频详情
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode", "appName"]),
  },
  components: {
    RelatedVideo,
    comment,
    operate,
    submitComment,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/video_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.videoInfo.title + " - 法治号客户端", _this.videoInfo.introduction, _this.shareUrl, _this.videoInfo.sharePictureUrl);
      }).catch((err) => {

      });
    },
    /* 获取视频详情 */
    getVideoDetail() {
      var _this = this;
      videoApi
        .getVideoDetailById(_this.detailParams)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.title;
            _this.videoInfo = res.data;
            _this.commentParams.contentId = _this.videoInfo.id;
            _this.commentParams.type = _this.videoInfo.contentType;
            _this.wechatShare(); // 微信二次分享
            _this.statistics(); // 统计
            _this.addScore(); // 增加积分
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.videoInfo.contentCreationTime, // 创建时间
        contentId: this.videoInfo.id, // 稿件Id
        contentTitle: this.videoInfo.title,
        contentType: 9,
        memberId: this.videoInfo.editorId, // 当前稿件的编辑者的id
        nickName: this.videoInfo.editor, // 当前稿件的编辑者的用户名称
      };
      if (this.detailParams.fromFlag == 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.videoInfo.channelId, // 栏目id
          channelName: this.videoInfo.channelName, // 栏目名称
        });
      } else if (this.detailParams.fromFlag == 1) {
        tj_params = Object.assign(tj_params, {
          channelId: this.videoInfo.specialId, // 专题id
          channelName: this.videoInfo.specialName, // 专题名称
        });
      } else if (this.detailParams.fromFlag == 2) {
        tj_params = Object.assign(tj_params, {
          channelId: this.videoInfo.channelJson.id, // 自媒体id
          channelName: this.videoInfo.channelJson.name, // 自媒体名称
        });
      }
      clickPlayCount(tj_params);
      this.trackArticlePV();
    },
    /* 稿件详情页浏览埋点 */
    trackArticlePV() {
      const extra = {};
      if (this.detailParams.fromFlag == 1) {
        extra.specialName = this.videoInfo.specialName;
      }
      trackArticleDetailPg(this.videoInfo, extra);
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "gksp", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: "观看视频", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: this.detailParams.contentType, // 非必传，稿件的type
        contentId: this.detailParams.contentId, // 非必传，稿件的id
        contentName: this.videoInfo.title, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    /* 显示或隐藏评论表单 */
    showCommentForm(data) {
      this.isShowCommentForm = data;
      this.commentParentId = "0";
    },
    /* 评论回复,显示评论表单 */
    showCommentReplayForm(data) {
      this.isShowCommentForm = true;
      this.commentParentId = data;
    },
    /* 滚动到评论区域或顶部 */
    isToComment(flag) {
      if (flag) {
        let top = this.$refs.comment.offsetTop;
        this.$nextTick(() => {
          this.$refs.detailBox.scrollTo({
            top: top,
            left: 0,
            behavior: "smooth",
          });
        });
      } else {
        this.$nextTick(() => {
          this.$refs.detailBox.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        });
      }
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.detailParams.contentType = Number(query.contentType) || 9;
      this.detailParams.contentId = Number(query.contentId);
      this.detailParams.fromFlag = Number(query.fromFlag) || 0;
      this.detailParams.cId = Number(query.cId) || 0;
      if (!!this.userInfo) {
        this.detailParams.memberId = this.userInfo.id;
      }
      this.detailParams.shareSign = query.shareSign;
      this.detailParams.timestamp = query.timestamp;
      this.getVideoDetail();
      loadStat(); // 友盟统计
    }
  },
};
</script>
<style scoped lang="scss">
.video_detail_container {
  width: 100%;
  height: 100%;
  padding: 0px 0px 40px;
  overflow-x: hidden;
  overflow-y: auto;
  .video_box {
    width: 100%;
    height: 100%;
    padding: 0;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    .player_box {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      background-color: #000;
      overflow: hidden;
      video {
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .detail_box {
      flex: 1;
      padding: 15px;
      overflow-x: hidden;
      overflow-y: auto;
      .detail_info {
        .title {
          line-height: 24px;
          margin-bottom: 10px;
          color: #000;
          font-size: 18px;
        }
        .detail_text {
          margin-bottom: 10px;
          color: #a1a1a1;
          font-size: 12px;
          .time {
            float: right;
          }
        }
        .detail_cont {
          overflow: hidden;
          height: auto;
          line-height: 24px;
          color: #646464;
          font-size: 16px;
          text-align: justify;
        }
      }
    }
  }
}
</style>